import React from 'react';
import { Box, Stack, Typography, Grid, Paper, FormLabel, Fade, Avatar } from '@mui/material';
import FormField from './FormField'; // Path নিশ্চিত করুন

const AssessmentSection = ({ section, index, control, errors }) => (
  <Fade in timeout={500 + index * 200}>
    <Box sx={{ mb: 6 }}>
      {/* UK Clinical Header Style */}
      <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 3 }}>
        <Avatar 
          sx={{ 
            bgcolor: '#101828', 
            width: 36, 
            height: 36, 
            fontSize: '14px', 
            fontWeight: 700 
          }}
        >
          {index + 1}
        </Avatar>
        <Typography variant="h6" fontWeight={800} color="#1D2939">
          {section.section_title}
        </Typography>
      </Stack>

      <Paper 
        variant="outlined" 
        sx={{ 
          p: 4, 
          borderRadius: '20px', 
          bgcolor: '#FCFCFD', 
          border: '1px solid #EAECF0',
          transition: '0.2s',
          '&:hover': { boxShadow: '0px 10px 20px rgba(0,0,0,0.02)' }
        }}
      >
        <Grid container spacing={4}>
          {section.questions.map((q) => (
            <Grid item xs={12} md={6} key={q.id}>
              <Box>
                <FormLabel 
                  sx={{ 
                    fontWeight: 700, 
                    color: '#344054', 
                    fontSize: '0.875rem', 
                    display: 'block', 
                    mb: 1.5 
                  }}
                >
                  {q.question_text} 
                  {q.required && <Box component="span" sx={{ color: '#D92D20', ml: 0.5 }}>*</Box>}
                </FormLabel>
                
                <FormField 
                  question={q} 
                  control={control} 
                  error={errors[`question_${q.id}`]} 
                />
                
                {errors[`question_${q.id}`] && (
                  <Typography variant="caption" color="error" sx={{ mt: 1, display: 'block', fontWeight: 600 }}>
                    This information is required for clinical audit
                  </Typography>
                )}
              </Box>
            </Grid>
          ))}
        </Grid>
      </Paper>
    </Box>
  </Fade>
);

export default AssessmentSection;